import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/loader.gif'
import _imports_1 from '@/assets/imgs/chip_selector.png'
import _imports_2 from '@/assets/imgs/chipsc.webp'
import _imports_3 from '@/assets/imgs/chipsc.png'
import _imports_4 from '@/assets/imgs/chips_seting_btn.webp'
import _imports_5 from '@/assets/imgs/chips_seting_btn.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2d19a3f7")

_pushScopeId("data-v-2d19a3f7")
const _hoisted_1 = _imports_2
const _hoisted_2 = _imports_4
const _hoisted_3 = { class: "pc-desk-root" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_5 = { class: "full_video_mode" }
const _hoisted_6 = { class: "center-content" }
const _hoisted_7 = { class: "video-and-summury" }
const _hoisted_8 = { class: "video-container" }
const _hoisted_9 = /*#__PURE__*/_createVNode("canvas", {
  id: "videoplayer2",
  class: "player"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("canvas", {
  id: "videoplayer1",
  class: "player"
}, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "loading"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("picture", null, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_13 = { class: "summury-and-prediction" }
const _hoisted_14 = { class: "summury" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "circle red" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "circle blue" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "circle green" }, "和", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = {
  key: 0,
  class: "item"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "circle red" }, "庄对", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = {
  key: 1,
  class: "item"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "circle blue" }, "闲对", -1)
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "prediction" }
const _hoisted_31 = { class: "bet-view-table-infor-and-chips" }
const _hoisted_32 = { class: "table-info" }
const _hoisted_33 = { class: "timer-status" }
const _hoisted_34 = { class: "status" }
const _hoisted_35 = { class: "info" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "局数", -1)
const _hoisted_37 = { class: "chips" }
const _hoisted_38 = {
  key: 0,
  src: _imports_1,
  class: "active",
  alt: ""
}
const _hoisted_39 = { class: "chip-container" }
const _hoisted_40 = {
  key: 0,
  src: _imports_1,
  class: "active",
  alt: ""
}
const _hoisted_41 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_1
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/chipsc.png"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_2
}, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/chips_seting_btn.png",
  draggable: "false"
}, null, -1)
const _hoisted_45 = { class: "map" }
const _hoisted_46 = { class: "footer" }
const _hoisted_47 = {
  key: 0,
  class: "notice-wrap"
}
const _hoisted_48 = { class: "notice-label" }
const _hoisted_49 = {
  key: 1,
  class: "contact-wrap"
}
const _hoisted_50 = { class: "time" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "icon-msg" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "icon-call" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "icon-warning" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "icon-agent" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "icon-max" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "icon-home" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_view = _resolveComponent("header-view")
  const _component_pop_alert_view = _resolveComponent("pop-alert-view")
  const _component_d_prediction_sumary_view = _resolveComponent("d-prediction-sumary-view")
  const _component_pc_bet_view = _resolveComponent("pc-bet-view")
  const _component_road_map_view = _resolveComponent("road-map-view")
  const _component_d_card_result_view = _resolveComponent("d-card-result-view")
  const _component_marquee_text = _resolveComponent("marquee-text")
  const _component_pc_switch_table = _resolveComponent("pc-switch-table")
  const _component_d_good_road_panel = _resolveComponent("d-good-road-panel")
  const _component_custom_money_view = _resolveComponent("custom-money-view")
  const _component_limit_dialog_view = _resolveComponent("limit-dialog-view")
  const _component_setting_view = _resolveComponent("setting-view")
  const _component_change_password_view = _resolveComponent("change-password-view")
  const _component_bet_history = _resolveComponent("bet-history")
  const _component_red_envelop_2 = _resolveComponent("red-envelop-2")
  const _component_rule_view = _resolveComponent("rule-view")

  return (_openBlock(), _createBlock("div", _hoisted_3, [
    _createVNode(_component_header_view, {
      class: "header",
      isOnLoby: false,
      title: _ctx.title,
      goodRoadCount: _ctx.goodRoadCount,
      onShowSwitchTable: _ctx.OnShowSwitchTable,
      onOnShowSingleShow: _ctx.OnShowGoodRoad,
      onOnShowLimit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLimitDialog = true)),
      onOnShowSetting: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSettings = true))
    }, null, 8, ["title", "goodRoadCount", "onShowSwitchTable", "onOnShowSingleShow"]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            (_ctx.videoIsLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _hoisted_12
                ]))
              : _createCommentVNode("", true),
            (_ctx.showSwitcher)
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: "view-switcher",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.OnCLickViewSwitcher && _ctx.OnCLickViewSwitcher(...args)))
                }, " 小视频 "))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: ["super-6-switcher", { 'is-disabled': _ctx.hasConfirmedBet }]
                }, [
                  _createVNode("span", {
                    class: { active: !_ctx.isSuper6Mode },
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSuper6Mode(false)))
                  }, "百家乐", 2),
                  _createVNode("span", {
                    class: { active: _ctx.isSuper6Mode },
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSuper6Mode(true)))
                  }, "免水百家乐", 2)
                ], 2))
              : _createCommentVNode("", true),
            _createVNode(_Transition, { name: "fadein-out" }, {
              default: _withId(() => [
                (_ctx.messageCounter > 0)
                  ? (_openBlock(), _createBlock(_component_pop_alert_view, {
                      key: 0,
                      class: "pop-alert-view",
                      mdata: _ctx.alertMessage
                    }, null, 8, ["mdata"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("span", _hoisted_16, _toDisplayString(_ctx.redLabel), 1),
                _createVNode("span", _hoisted_17, _toDisplayString(_ctx.redCount), 1)
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("span", _hoisted_19, _toDisplayString(_ctx.blueLabel), 1),
                _createVNode("span", _hoisted_20, _toDisplayString(_ctx.blueCount), 1)
              ]),
              _createVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode("span", _hoisted_23, _toDisplayString(_ctx.greenCount), 1)
              ]),
              (_ctx.gameType === 'G002')
                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode("span", _hoisted_26, _toDisplayString(_ctx.redPairCount), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.gameType === 'G002')
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("span", _hoisted_29, _toDisplayString(_ctx.bluePairCount), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode(_component_d_prediction_sumary_view, {
                class: "item-pre",
                label: _ctx.gameType === 'G002' ? '庄' : '龙',
                color: 2,
                preType: 1,
                preData: _ctx.nextBlueRoadMapSummaryData,
                onOnpredict: _ctx.handleOnPredict
              }, null, 8, ["label", "preData", "onOnpredict"]),
              _createVNode(_component_d_prediction_sumary_view, {
                class: "item-pre",
                label: _ctx.gameType === 'G002' ? '闲' : '虎',
                color: 1,
                preType: 2,
                preData: _ctx.nextRedRoadMapSummaryData,
                onOnpredict: _ctx.handleOnPredict
              }, null, 8, ["label", "preData", "onOnpredict"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_31, [
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, [
              _createVNode("span", {
                class: ["timer", [
                                    _ctx.timerColor,
                                    _ctx.currentCount < 11 && _ctx.currentCount > -1
                                        ? 'pulsing'
                                        : ''
                                ]],
                "data-timer": 
                                    _ctx.currentCount != -1 ? _ctx.currentCount : ''
                                
              }, _toDisplayString(_ctx.currentCount != -1 ? _ctx.currentCount : ''), 11, ["data-timer"]),
              _createVNode("span", _hoisted_34, _toDisplayString(_ctx.currentCount > -1
                                    ? _ctx.iN('desk.startbet')
                                    : _ctx.iN('desk.nobet')), 1)
            ]),
            _createVNode("div", _hoisted_35, [
              _createVNode("div", null, [
                _hoisted_36,
                _createVNode("span", null, _toDisplayString(_ctx.shoe) + "/" + _toDisplayString(_ctx.juNo), 1)
              ]),
              _createVNode("div", null, [
                _createVNode("span", null, _toDisplayString(_ctx.iN('desk.gamenumber')), 1),
                _createVNode("span", null, _toDisplayString(_ctx.deskGameId), 1)
              ])
            ])
          ]),
          _createVNode(_component_pc_bet_view, {
            class: "bet-views",
            gameType: _ctx.gameType,
            chipValue: _ctx.chip,
            allowBet: _ctx.allowBet,
            s6Mode: _ctx.isSuper6Mode,
            onBetSuccess: _ctx.handleOnBetSuccess,
            ref: "betview"
          }, null, 8, ["gameType", "chipValue", "allowBet", "s6Mode", "onBetSuccess"]),
          _createVNode("div", _hoisted_37, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chips, (chpAmt, i) => {
              return (_openBlock(), _createBlock("div", {
                class: "chip-container",
                key: i
              }, [
                (_ctx.chipIndex === i)
                  ? (_openBlock(), _createBlock("img", _hoisted_38))
                  : _createCommentVNode("", true),
                _createVNode("picture", {
                  class: "chip",
                  onClick: ($event: any) => (_ctx.chipClicked(i, chpAmt))
                }, [
                  _createVNode("source", {
                    type: "image/webp",
                    srcset: _ctx.getChipImageWebp(chpAmt)
                  }, null, 8, ["srcset"]),
                  _createVNode("img", {
                    src: _ctx.getChipImageWebpPng(chpAmt),
                    "data-was-processed": "true",
                    "data-src": _ctx.getChipImageWebpPng(chpAmt),
                    draggable: "false"
                  }, null, 8, ["src", "data-src"])
                ], 8, ["onClick"])
              ]))
            }), 128)),
            _createVNode("div", _hoisted_39, [
              (_ctx.chipIndex === 5)
                ? (_openBlock(), _createBlock("img", _hoisted_40))
                : _createCommentVNode("", true),
              _createVNode("picture", {
                class: "chip",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showChipDialog(false))),
                draggable: "false"
              }, [
                _hoisted_41,
                _hoisted_42,
                _createVNode("span", null, _toDisplayString(_ctx.getCustomChipValue()), 1)
              ])
            ]),
            _createVNode("picture", {
              class: "chip-setting",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showChipDialog(true)))
            }, [
              _hoisted_43,
              _hoisted_44
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_45, [
        _createVNode(_component_road_map_view, {
          class: "road-map-view",
          mapData: _ctx.tableResult,
          predictionEnabled: true,
          gameType: _ctx.gameType,
          onRoadMapData: _ctx.UpdateRoadMapData,
          ref: "roadmapview"
        }, null, 8, ["mapData", "gameType", "onRoadMapData"]),
        (_ctx.showPokerCards)
          ? (_openBlock(), _createBlock(_component_d_card_result_view, {
              key: 0,
              class: "d-card-result-view",
              gameType: _ctx.gameType,
              gameResult: _ctx.currentGameResult
            }, null, 8, ["gameType", "gameResult"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_46, [
      (_ctx.isNoticeView)
        ? (_openBlock(), _createBlock("div", _hoisted_47, [
            _createVNode("span", _hoisted_48, _toDisplayString(_ctx.iN('desk.latestnews')) + ":", 1),
            _createVNode("div", {
              class: "notice",
              onMouseover: _cache[8] || (_cache[8] = ($event: any) => (_ctx.noticeIsPaused = true)),
              onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.noticeIsPaused = false))
            }, [
              _createVNode(_component_marquee_text, {
                class: "m-notice",
                key: _ctx.deskInfoKey,
                animate: !_ctx.noticeIsPaused,
                speed: 30
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.deskNotice), 1)
                ]),
                _: 1
              }, 8, ["animate"])
            ], 32)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_49, [
            _createVNode("span", null, _toDisplayString(_ctx.iN('desk.servicehotline')) + " +85585801111", 1)
          ])),
      _createVNode("div", _hoisted_50, _toDisplayString(_ctx.dateTimeStr), 1),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isNoticeView = true))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
        }, _toDisplayString(_ctx.iN('desk.latestnews')), 1),
        _hoisted_51
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isNoticeView = false))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
        }, _toDisplayString(_ctx.iN('desk.servicehotline')), 1),
        _hoisted_52
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.OnClickRules && _ctx.OnClickRules(...args)))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
        }, _toDisplayString(_ctx.iN('setting.rule')), 1),
        _hoisted_53
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.OnClickCustumerService && _ctx.OnClickCustumerService(...args)))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
        }, _toDisplayString(_ctx.iN('setting.customerservice')), 1),
        _hoisted_54
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.OnCLickToggleFullScreen && _ctx.OnCLickToggleFullScreen(...args)))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
        }, _toDisplayString(_ctx.iN('common.fullscreen')), 1),
        _hoisted_55
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.goToLoby && _ctx.goToLoby(...args)))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
        }, _toDisplayString(_ctx.iN('common.lobby')), 1),
        _hoisted_56
      ])
    ]),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withId(() => [
        (_ctx.showSwicthTable)
          ? (_openBlock(), _createBlock(_component_pc_switch_table, {
              key: 0,
              class: "switch-desk",
              onOnHideSwitchTable: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showSwicthTable = false)),
              onOnSwitchTable: _ctx.onSwitchTable
            }, null, 8, ["onOnSwitchTable"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withId(() => [
        (_ctx.showGoodRoadPanel)
          ? (_openBlock(), _createBlock(_component_d_good_road_panel, {
              key: 0,
              class: "good-road-panel",
              onOnHideGoodRoad: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showGoodRoadPanel = false)),
              onOnGoodRoadSync: _ctx.onGoodRoadSync,
              onOnSwitchTable: _ctx.onSwitchTable
            }, null, 8, ["onOnGoodRoadSync", "onOnSwitchTable"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showCustumChip)
          ? (_openBlock(), _createBlock(_component_custom_money_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showCustumChip = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showLimitDialog)
          ? (_openBlock(), _createBlock(_component_limit_dialog_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showLimitDialog = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showSettings)
          ? (_openBlock(), _createBlock(_component_setting_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showSettings = false)),
              onOnShowChangePasswordForm: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showPasswordForm = true)),
              onOnShowHistory: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showHistory = true)),
              onOnShowRule: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showRule = true))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showPasswordForm)
          ? (_openBlock(), _createBlock(_component_change_password_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showPasswordForm = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showHistory)
          ? (_openBlock(), _createBlock(_component_bet_history, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showHistory = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-out" }, {
      default: _withId(() => [
        (_ctx.showPacket2)
          ? (_openBlock(), _createBlock(_component_red_envelop_2, {
              key: 0,
              class: "full-dialog",
              redpackets: _ctx.packet2s,
              onClose: _ctx.onPacket2Close
            }, null, 8, ["redpackets", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-out" }, {
      default: _withId(() => [
        (_ctx.showRule)
          ? (_openBlock(), _createBlock(_component_rule_view, {
              key: 0,
              class: "full-dialog",
              onClose: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showRule = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})